import React, { useState, useEffect } from 'react';
import { Button, Col, Container, Form, Modal, Row, Spinner } from 'react-bootstrap';
import AppSpinner from '../Extras/AppSpinner/AppSpinner';
import { setUpdateUserInfo } from '../../redux/modules/auth';
import Slider from 'react-slick';
import { connect } from 'react-redux';
import { apiUrl, businessName } from '../../utils/consts';
import Score from '../Score/Score';
import { couponBenefits } from '../../utils/couponCategories';
import './styles/benefitInfo.scss';

const select = state => {
  return {
    userId: state.auth.userId,
    token: state.auth.token,
    user: state.auth.user
  };
};

function mapDispatchToProps(dispatch) {
  return {
    setUpdateUserInfo: payload => dispatch(setUpdateUserInfo(payload))
  };
}

function ConnectedBenefitInfoComponent(props) {

  const { match, user } = props;
  const id = match.params.id;

  const [loading, setLoading] = useState(true);
  const [validated, setValidated] = useState(false);
  const [details, setDetails] = useState();
  const [benefit, setBenefit] = useState();
  const [selectedSlide, setSelectedSlide] = useState();
  const [creating, setCreating] = useState(false);
  const [showApplyModal, setShowApplyModal] = useState(false);
  const [existingApplication, setExistingApplication] = useState(false);
  const [approving, setApproving] = useState(false);
  const [declining, setDeclining] = useState(false);
  const [applyingStage, setApplyingStage] = useState(!user.nibiBusinessHasScore ? 0 : 1);
  const [anonymousRequest, setAnonymousRequest] = useState(true);

  const fetchData = async () => {
    setLoading(true);

    const benefitResp = fetch(`${apiUrl}/benefits/get/${id}`);
    const applicationResp = fetch(`${apiUrl}/benefitApplications/get/${id}/${props.userId}`);

    const benefitJson = await (await benefitResp).json();

    if (benefitJson.success) {
      const { benefit } = benefitJson;

      if (benefit.benefitType === 'COUPON') {
        const couponBenefit = couponBenefits.find(it => it.id === benefit.category);

        setSelectedSlide(<img className="selectedSlideImage" src={couponBenefit.thumbnail} />);
        setBenefit(couponBenefit);
      } else { 
        setSelectedSlide(<img className="selectedSlideImage" src={benefit.thumbnail} />);
        setBenefit(benefit);
      }
    }

    const applicationJson = await (await applicationResp).json();

    if (applicationJson.success) setExistingApplication(applicationJson.existingApplication);

    setLoading(false);
  };

  useEffect(() => {
    if (props.userId) fetchData();
  }, [id]);

  const updateScoreCallback = () => {
    setApplyingStage(1);
    props.setUpdateUserInfo({ update: true });
  };

  const handleClose = () => {
    if (applyingStage === 2) fetchData();

    setApplyingStage(!user.nibiBusinessHasScore ? 0 : 1);
    setShowApplyModal(false);
  };

  const handleApply = async event => {
    event.preventDefault();
    event.stopPropagation();

    setValidated(true);

    const form = event.currentTarget;

    if (form.checkValidity()) {

      setCreating(true);
      const { userId, token } = props;

      const prom = await fetch(`${apiUrl}/benefitApplications/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          token,
          userId,
          businessName,
          type: benefit.benefitType,
          category: benefit.benefitType === 'COUPON' ? benefit.id : '',
          benefit,
          benefitId: id,
          anonymousRequest,
          details
        })
      });

      const json = await prom.json();

      if (json.success) setApplyingStage(2);
      else alert(json.message || 'Error. Inténtalo nuevamente.');

      setCreating(false);
    }
  };

  const handleApproveBenefit = async () => {
    const { userId, token } = props;

    setApproving(true);

    const approveProm = await fetch(`${apiUrl}/benefits/approve`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        token,
        userId,
        businessName,
        id: benefit._id
      })
    });

    const approveJson = await approveProm.json();

    if (approveJson.success) refresh('Ayuda aprobada con éxito.');
    else alert(approveJson.message || 'Error. Inténtalo nuevamente.');

    setApproving(false);
  };

  const handleRejectBenefit = async () => {
    const { userId, token } = props;

    setDeclining(true);

    const declineProm = await fetch(`${apiUrl}/benefits/decline`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        token,
        userId,
        businessName,
        id: benefit._id
      })
    });

    const declineJson = await declineProm.json();

    if (declineJson.success) refresh('Ayuda rechazada con éxito.');
    else alert(declineJson.message || 'Error. Inténtalo nuevamente.');

    setDeclining(false);
  };

  const refresh = message => {
    alert(message);
    fetchData();
  };

  if (loading || !benefit || !props.token) {
    return (
      <div className="benefit-info-component">
        <Container>
          <AppSpinner />
        </Container>
      </div>
    );
  }

  const photosArr = benefit.photos || [];
  const settings = {
    infinite: true,
    arrows: true,
    speed: 500,
    slidesToShow: benefit.photos.length <= 4 ? benefit.photos.length : 4,
    slidesToScroll: 3
  };

  return (
    <div className="benefit-info-component">
      <Container>
        <Row>
          <Col lg={6}>
            <div className="selectedSlideContainer">{selectedSlide}</div>
            <div className="sliderContainer">
              <Slider {...settings}>
                {
                  photosArr.map((photo, i) =>
                    <div key={i} onClick={() => setSelectedSlide(
                      <img className="selectedSlideImage" src={photo} alt="Foto del programa" />
                    )}>
                      <img className="carouselImage" src={photo} alt="Miniatura de foto del producto" />
                    </div>
                  )
                }
              </Slider>
            </div>
          </Col>
          <Col lg={6}>
            <h1>
              {benefit.name}
            </h1>
            {
              benefit.location && <h6>Ubicación: {benefit.location}</h6>
            }
            <p className="benefit-description">
              {benefit.description}
            </p>
            {
              benefit.details &&
              <>
                <h6>Detalles</h6>
                <p className="benefit-description">
                  {benefit.details}
                </p>
              </>
            }
            {
              user.nibiBusinessRole !== 'ADMIN' ?
              (
                existingApplication ? <p>Ya aplicaste a esta ayuda</p> :
                <Button className="benefit-add-to-cart" onClick={() => setShowApplyModal(true)}>
                  Aplicar a esta ayuda
                </Button>
              ) :
              <div className="benefit-admin-options">
                {
                  benefit.benefitType !== 'COUPON' &&
                  (benefit.status === 'PENDING' ?
                  <>
                    <Button className="benefit-admin-btn" onClick={handleApproveBenefit} variant="info" disabled={approving}>
                      {
                        approving ? <Spinner variant="warning" size="sm" animation="border" /> :
                        'Aprobar ayuda'
                      }
                    </Button>
                    <Button className="benefit-admin-btn" onClick={handleRejectBenefit} variant="danger" disabled={declining}>
                      {
                        declining ? <Spinner variant="warning" size="sm" animation="border" /> :
                        'Rechazar ayuda'
                      }
                    </Button>
                  </> :
                  benefit.status === 'AVAILABLE' ?
                  <Button className="benefit-admin-btn" onClick={handleRejectBenefit} variant="danger" disabled={declining}>
                    {
                      declining ? <Spinner variant="warning" size="sm" animation="border" /> :
                      'Eliminar ayuda'
                    }
                  </Button> :
                  benefit.status === 'DECLINED' ?
                  <Button className="benefit-admin-btn" onClick={handleApproveBenefit} variant="info" disabled={approving}>
                    {
                      approving ? <Spinner variant="warning" size="sm" animation="border" /> :
                      'Aprobar ayuda'
                    }
                  </Button> :
                  <div></div>)
                }
              </div>
            }
          </Col>
        </Row>
      </Container>

      <Modal show={showApplyModal} onHide={handleClose} size="lg">
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="benefit-info-modal">
          {
            applyingStage === 0 ? <Score successCallback={updateScoreCallback} /> :
            applyingStage === 1 ?
            <Form noValidate validated={validated} onSubmit={handleApply}>
              {/* <h5 className="title">
                ¿Deseas solicitar esta ayuda anónimamente?
              </h5> */}
              <Form.Group>
                <Form.Label>Comentarios (opcional)</Form.Label>
                <Form.Control
                  value={details}
                  onChange={e => setDetails(e.target.value)}
                  placeholder="Si deseas deja un comentario acerca de por qué aplicas a esta ayuda"
                  type="text"
                  as="textarea"
                  rows="3"
                />
              </Form.Group>
              <div className="custom-control custom-checkbox">
                <input checked={anonymousRequest} onChange={() => setAnonymousRequest(!anonymousRequest)} type="checkbox" className="custom-control-input" id="anonymCb" />
                <label className="custom-control-label" htmlFor="anonymCb">
                  Quiero crear esta solicitud de forma anónima.
                </label>
              </div>
              <div className="coupon-anonym-options">
                <Button className="app-button" type="submit" disabled={creating}>
                  {
                    creating ? <Spinner variant="warning" size="sm" animation="border" /> :
                    'Confirmar'
                  }
                </Button>
              </div>
            </Form> :
            <>
              <h3 className="title">
                Aplicaste a esta ayuda correctamente. Te notificaremos del resultado de esta aplicación más adelante.
              </h3>
              <Button className="app-button" onClick={handleClose}>
                Aceptar
              </Button>
            </>
          }
        </Modal.Body>
      </Modal>
    </div>
  );
}

const BenefitInfoComponent = connect(select, mapDispatchToProps)(ConnectedBenefitInfoComponent);

export default BenefitInfoComponent;
